import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../redux/axios";
import {
  getItemWithExpiry,
  removeItemWithExpiry,
  setItemWithExpiry,
  storeItem,
} from "../../lib/utility";

const initialState = {
  userData: [],
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  isFetchingMobileEmail: false,
  walletFlagType: false,
  walletInfoList: [],
  isFetchingUserGet: false,
  isFetchingUserUpdate: false,
  isFetchingUserDelete: false,
  isFetchingMultiGet: false,
  isFetchingMultiUpdate: false,
  isFetchingMultiDelete: false,
  userLimitData: [],
  isFetchingLimitsGet: false,
  isFetchingLimitsUpdate: false,
  isFetchingLimitsDelete: false,
  isFetchingMultiUserAcessGet: false,
  isFetchingUserList: false,
  isFetchingUserBalance: false,
  isFetchingUserConfigurations: false,
  isFetchingUserSessions: false,
  smscNames: [],
  isSuccessSmscNames: false,
  isErrorSmscNames: false,
  errorMessageSmscNames: "",
  isFetchingWebAccessLog: false,
  isFetchingTokenDetails: false,
  isFetchingGenerateToken: false,
  isFetchingHlrSchedule: false,
  isFetchingAddHlrSchedule: false,
  isFetchingEditHlrSchedule: false,
  isFetchingDeleteHlrSchedule: false,
 
  errorCodeUserData: [],
  totalItems: 0,
  currentPage: 0,
  totalPages: 0,
  isFetchingErrorCodeUser: false,
  isFetchingCreateErrorCodeUser: false,
  isFetchingEditErrorCodeUser: false,
  isFetchingDeleteErrorCodeUser: false,
 
  userListData: {
    data: [],
    totalItems: 0,
    currentPage: 0,
    totalPages: 0,
  },
  isFetchingUserListNew: false,
  userListTotalItems: 0,
  userListCurrentPage: 0,
  userListTotalPages: 0,
  isFetchingAbacPermissions: false,
  isFetchingAbacSave: false,
};

export const checkUserStatus = createAsyncThunk(
  "user/data-status",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      if (!tokenStr) return thunkAPI.rejectWithValue({ message: "No Token" });
      const { data, status } = await axios.get("/login/status", {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const userDataGet = createAsyncThunk(
  "user/data-get",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get("/users/?userId=" + udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const limitGet = createAsyncThunk(
  "user/limit-get",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const params = new URLSearchParams();
      if (udata?.pageNumber !== undefined)
        params.append("page", udata.pageNumber);
      if (udata?.pageSize !== undefined) params.append("size", udata.pageSize);
      if (udata?.searchTerm) params.append("search", udata.searchTerm);
      if (udata?.sortBy) params.append("sortBy", udata.sortBy);
      if (udata?.sortDirection)
        params.append("sortDirection", udata.sortDirection);
      if (udata?.targetUsername)
        params.append("targetUsername", udata.targetUsername);
      const queryString = params.toString();
      const url = `/limits/list${queryString ? `?${queryString}` : ""}`;
      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const userDataSave = createAsyncThunk(
  "user/data-save",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const url = `/users/save`;
      const { data, status } = await axios.post(url, udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const multiAccessSave = createAsyncThunk(
  "user/multi-save",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.post("/multiUser/save", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const limitSave = createAsyncThunk(
  "user/limit-save",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.post("/limits/save", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const userDataUpdate = createAsyncThunk(
  "user/data-update",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        "/users/update?userId=" + udata.userId,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const multiAcessUpdate = createAsyncThunk(
  "user/multi-update",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put("/multiUser/update", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const limitUpdate = createAsyncThunk(
  "user/limit-update",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put("/limits/update", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const userDataDelete = createAsyncThunk(
  "user/data-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.delete(
        "/users/delete?userId=" + udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const multiAcessDelete = createAsyncThunk(
  "user/multi-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
     
      const idsParam = Array.isArray(udata.ids)
        ? udata.ids.join(",")
        : udata.ids;
      const { data, status } = await axios.delete(
        `/multiUser/delete?ids=${idsParam}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const limitDelete = createAsyncThunk(
  "user/limit-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.delete("/limits/delete/" + udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const userListGet = createAsyncThunk(
  "users/preInformation",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      // Scope the cache key to the logged-in user so a different user logging
      // in on the same tab doesn't reuse the previous user's cached list.
      const requestUserId = auth?.user?.id ?? "unknown";
      const cacheKey = `usersList${udata}_${requestUserId}`;
      const usersData = getItemWithExpiry(cacheKey);
      if (usersData) {
        return { ...usersData, status: 200 };
      }
      const url = `/users/pre-information?purpose=${udata}&walletFlag=707`;
      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        setItemWithExpiry(cacheKey, data, 5);
        return { ...data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const multiUserListAccess = createAsyncThunk(
  "users/multiListAccess",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const params = new URLSearchParams();
      params.set("userId", String(udata.userId ?? ""));
      if (udata.search != null && String(udata.search).trim() !== "") {
        params.set("search", String(udata.search).trim());
      }
      if (udata.sortBy) params.set("sortBy", udata.sortBy);
      if (udata.sortDirection) params.set("sortDirection", udata.sortDirection);
      if (udata.pageNumber != null) params.set("pageNumber", String(udata.pageNumber));
      if (udata.pageSize != null) params.set("pageSize", String(udata.pageSize));
      if (udata.toGmt != null && udata.toGmt !== "") {
        params.set("toGmt", String(udata.toGmt));
      }
      if (udata.startDate) params.set("startDate", udata.startDate);
      if (udata.endDate) params.set("endDate", udata.endDate);

      const url = `/multiUser/list/access?${params.toString()}`;
      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { ...data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

/** GET /multiUser/permissions/{accessId} — Manage Permissions editor load. */
export const getAbacPermissions = createAsyncThunk(
  "users/getAbacPermissions",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      if (!tokenStr) return thunkAPI.rejectWithValue({ message: "No Token" });

      const accessId =
        typeof udata === "object" && udata != null
          ? udata.accessId ?? udata.id
          : udata;
      if (accessId == null || accessId === "") {
        return thunkAPI.rejectWithValue({ message: "Access id required" });
      }

      const { data, status } = await axios.get(
        `/multiUser/permissions/${accessId}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      }
      return thunkAPI.rejectWithValue(data);
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

/** PUT /multiUser/update-permissions — Manage Permissions save. */
export const saveAbacPermissions = createAsyncThunk(
  "users/saveAbacPermissions",
  async (body, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      if (!tokenStr) return thunkAPI.rejectWithValue({ message: "No Token" });

      const { data, status } = await axios.put(
        `/multiUser/update-permissions`,
        body,
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      }
      return thunkAPI.rejectWithValue(data);
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const updateUserBalance = createAsyncThunk(
  "users/update-balance",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const url = "/balance/updateBalance";
      const { data, status } = await axios.post(url, udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getUsersConfigurations = createAsyncThunk(
  "users/get-configurations",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      
      const userIds = udata === "ALL" ? "" : udata;
      const url = "/users/configurations?userIds=" + userIds;
      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getUsersSessions = createAsyncThunk(
  "users/get-sessions",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
     
      const userIds = udata === "ALL" ? "" : udata;
      const url = "/users/sessions?userIds=" + userIds;
      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const updateFlag = createAsyncThunk(
  "users/flag-update",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
     
    
      let userIdsParam = "";
     
     
     
      
      if (udata.isSearchMode === true && Array.isArray(udata.ids) && udata.ids.length > 0) {
        userIdsParam = udata.ids.join(",");
      }
     
      else if (udata.allSelected === true || udata.ids === "ALL") {
        
        userIdsParam = "";
      }
    
      else if (Array.isArray(udata.ids) && udata.ids.length > 0) {
        userIdsParam = udata.ids.join(",");
      }
      else if (Array.isArray(udata.userIds) && udata.userIds.length > 0) {
        userIdsParam = udata.userIds.join(",");
      }
      else {
        return thunkAPI.rejectWithValue({ message: "No valid user IDs" });
      }
     
    
      let url = `/users/flagUpdate?flagValue=${udata.flag}`;
      if (userIdsParam !== undefined) {
        url += `&userIds=${userIdsParam}`;
      }
      const { data, status } = await axios.post(
        url,
        {},
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error('❌ Network Error:', err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const userBatchIds = createAsyncThunk(
  "users/batch-id",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const url = "/users/batch-id";
      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);


export const getUserWalletInfo = createAsyncThunk(
  "users/wallet-info",
  
  async (username, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const url = "/users/users-data";
      const headers = { Authorization: `Bearer ${tokenStr}` };
      // if (username) {
      //   headers.username = username;
      // }
      const { data, status } = await axios.get(url, { headers });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getSmscNames = createAsyncThunk(
  "smsc-names",
  async (udata, thunkAPI) => {
    try {
      const smscNames = getItemWithExpiry("smscNames");
      if (smscNames) {
        return { data: smscNames, status: 200 };
      }
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(`/users/smsc-names`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      });
      if (status.toString().startsWith("2")) {
        setItemWithExpiry("smscNames", data, 10800);
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const editTransactionMode = createAsyncThunk(
  "balance/updateBalanceMode",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.post(
        `/balance/updateBalanceMode?walletFlag=${udata.walletFlag}&userId=${udata.userId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
          },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const fetchTokenDetails = createAsyncThunk(
  "login/token-details",
  async (userId, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(
        `/login/token-details?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            accept: "*/*",
          },
        },
      );
      if (status.toString().startsWith("2")) {
        return data;
      }
      return thunkAPI.rejectWithValue({ ...data, status });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  },
);

export const generateUserToken = createAsyncThunk(
  "login/generate-token",
  async (requestData, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const headers = {
        Authorization: `Bearer ${tokenStr}`,
        "Content-Type": "application/json",
      };
      if (globalThis.username) headers.username = globalThis.username;
      if (globalThis.ipAddress) headers.ipAddress = globalThis.ipAddress;

      const { data, status } = await axios.post(
        "/login/generate-token",
        requestData,
        { headers },
      );
      if (status.toString().startsWith("2")) {
        return data;
      }
      return thunkAPI.rejectWithValue(data);
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const getWebAccessLog = createAsyncThunk(
  "users/access-logs",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      let url;
      if (typeof udata === "string") {
        url = `/users/access-logs${udata}`;
      } else {
        const params = new URLSearchParams();
        if (udata?.systemid) params.append("systemid", udata.systemid);
        if (udata?.pageNo !== undefined) params.append("pageNo", udata.pageNo);
        if (udata?.pageSize !== undefined)
          params.append("pageSize", udata.pageSize);
        if (udata?.sortBy) params.append("sortBy", udata.sortBy);
        if (udata?.sortDirection)
          params.append("sortDirection", udata.sortDirection);
        if (udata?.search)
          params.append("search", encodeURIComponent(udata.search));
        const queryString = params.toString();
        url = `/users/access-logs${queryString ? `?${queryString}` : ""}`;
      }
      const { data, status } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      });
    
      if (status === 404) {
        return {
          data: {
            data: [],
            currentPage: 0,
            totalPages: 0,
            totalItems: 0,
          },
          status,
        };
      }
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("err ===>", err);
     
      if (err.response?.status === 404) {
        return {
          data: {
            data: [],
            currentPage: 0,
            totalPages: 0,
            totalItems: 0,
          },
          status: 404,
        };
      }
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getHlrSchedule = createAsyncThunk(
  "users/hlr-schedules",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(`/users/hlr-schedules`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const addHlrSchedule = createAsyncThunk(
  "users/hlr-schedules/add",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.post(`/users/hlr-schedules`, udata, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const editHlrSchedule = createAsyncThunk(
  "users/hlr-schedules/edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        "/users/hlr-schedules/" + udata.id,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const deleteHlrSchedule = createAsyncThunk(
  "users/hlr-schedules/delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.delete(
        "/users/hlr-schedules/" + udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getMobileEmailById = createAsyncThunk(
  "sales/sales-Users",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(`/sales/sales-Users/${udata}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getErrorCodeUserData = createAsyncThunk(
  "users/user-error-codes",
  async (
    {
      pageNumber = 0,
      pageSize = 10,
      sortBy = "id",
      sortDirection = "asc",
      searchTerm,
      description,
      errorName,
      type,
    },
    thunkAPI
  ) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      let url = `/users/user-error-codes/all?page=${pageNumber}&size=${pageSize}&sortBy=${sortBy}&sortDirection=${sortDirection.toUpperCase()}`;
      if (searchTerm) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }
      if (description && description.trim() !== "") {
        url += `&filterDescription=${encodeURIComponent(description.trim())}`;
      }
      if (errorName && errorName.trim() !== "") {
        url += `&filterErrorName=${encodeURIComponent(errorName.trim())}`;
      }
      if (type && type.trim() !== "") {
        url += `&filterType=${encodeURIComponent(type.trim())}`;
      }
      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return {
          data: data.data || [],
          currentPage: data.currentPage || 0,
          totalPages: data.totalPages || 0,
          totalItems: data.totalItems || 0,
        };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("err ===>", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const createErrorCodeUserData = createAsyncThunk(
  "users/error-code-create",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.post(
        "/users/user-error-codes/create",
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const editErrorCodeUserData = createAsyncThunk(
  "users/error-code-edit",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        `/users/user-error-codes/update/${udata.id}`,
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const deleteErrorCodeUserData = createAsyncThunk(
  "users/error-code-delete",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.delete(
        `/users/user-error-codes/delete/${udata.id}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getErrorCodeUserById = createAsyncThunk(
  "users/error-code-get-by-id",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(
        `/users/user-error-codes/${udata.id}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue({ data, status });
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        data: err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const getUserList = createAsyncThunk(
  "users/user-list",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;
      const params = new URLSearchParams();
      if (udata?.sortBy) params.append("sortBy", udata.sortBy);
      if (udata?.sortDirection)
        params.append("sortDirection", udata.sortDirection);
      if (udata?.pageNumber !== undefined)
        params.append("pageNumber", udata.pageNumber);
      if (udata?.pageSize !== undefined)
        params.append("pageSize", udata.pageSize);
      if (udata?.search) params.append("search", udata.search);
      
      if (udata?.startDate) params.append("startDate", udata.startDate);
      if (udata?.endDate) params.append("endDate", udata.endDate);
      if (udata?.toGmt !== undefined) params.append("toGmt", udata.toGmt);
      const filterSystemId = udata?.filterSystemId || udata?.systemId;
      if (filterSystemId && filterSystemId.trim() !== "")
        params.append("filterSystemId", filterSystemId.trim());
      if (udata?.masterId && udata.masterId.trim() !== "") params.append("masterId", udata.masterId.trim());
      if (udata?.currency && udata.currency.trim() !== "") params.append("currency", udata.currency.trim());
      if (udata?.walletFlag && udata.walletFlag.trim() !== "") params.append("walletFlag", udata.walletFlag.trim());
      const queryString = params.toString();
      const url = `/users/user-list${queryString ? `?${queryString}` : ""}`;
      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue({ ...data, status });
      }
    } catch (err) {
      console.error("err ===>", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearStateUser: (state) => {
      state.userData = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
    },
    clearStateSmscNames: (state, { payload }) => {
      state.smscNames = [];
      state.isFetching = false;
      state.isSuccessSmscNames = false;
      state.isErrorSmscNames = false;
      state.errorMessageSmscNames = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userDataGet.pending, (state) => {
        state.isFetchingUserGet = true;
      })
      .addCase(userDataGet.fulfilled, (state) => {
        state.isFetchingUserGet = false;
      })
      .addCase(userDataGet.rejected, (state) => {
        state.isFetchingUserGet = false;
      })
      .addCase(limitGet.pending, (state) => {
        state.isFetchingLimitsGet = true;
      })
      .addCase(limitGet.fulfilled, (state, action) => {
        state.userLimitData = action.payload?.data;
        state.isFetchingLimitsGet = false;
      })
      .addCase(limitGet.rejected, (state) => {
        state.isFetchingLimitsGet = false;
        if (Array.isArray(state.userLimitData)) {
          state.userLimitData = [];
        } else {
          state.userLimitData = {
            ...(typeof state.userLimitData === "object" && state.userLimitData !== null
              ? state.userLimitData
              : {}),
            data: [],
            totalItems: 0,
            currentPage: 0,
            totalPages: 0,
          };
        }
      })
      .addCase(userDataSave.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(userDataSave.fulfilled, (state) => {
        state.isFetching = false;
        removeItemWithExpiry("usersListtxnmode");
        removeItemWithExpiry("usersListeditUser");
        removeItemWithExpiry("usersListbalance");
        removeItemWithExpiry("usersListlist");
        removeItemWithExpiry("listUsersadd");
        removeItemWithExpiry("listUserssearch");
      })
      .addCase(userDataSave.rejected, (state) => {
        state.isFetching = false;
      })
      .addCase(multiAccessSave.pending, (state) => {
        state.isFetchingMultiUpdate = true;
      })
      .addCase(multiAccessSave.fulfilled, (state) => {
        state.isFetchingMultiUpdate = false;
      })
      .addCase(multiAccessSave.rejected, (state) => {
        state.isFetchingMultiUpdate = false;
      })
      .addCase(getAbacPermissions.pending, (state) => {
        state.isFetchingAbacPermissions = true;
      })
      .addCase(getAbacPermissions.fulfilled, (state) => {
        state.isFetchingAbacPermissions = false;
      })
      .addCase(getAbacPermissions.rejected, (state) => {
        state.isFetchingAbacPermissions = false;
      })
      .addCase(saveAbacPermissions.pending, (state) => {
        state.isFetchingAbacSave = true;
      })
      .addCase(saveAbacPermissions.fulfilled, (state) => {
        state.isFetchingAbacSave = false;
      })
      .addCase(saveAbacPermissions.rejected, (state) => {
        state.isFetchingAbacSave = false;
      })
      .addCase(limitSave.pending, (state) => {
        state.isFetchingLimitsUpdate = true;
      })
      .addCase(limitSave.fulfilled, (state) => {
        state.isFetchingLimitsUpdate = false;
      })
      .addCase(limitSave.rejected, (state) => {
        state.isFetchingLimitsUpdate = false;
      })
      .addCase(userDataUpdate.pending, (state) => {
        state.isFetchingUserUpdate = true;
      })
      .addCase(userDataUpdate.fulfilled, (state) => {
        state.isFetchingUserUpdate = false;
        removeItemWithExpiry("usersListtxnmode");
        removeItemWithExpiry("usersListeditUser");
        removeItemWithExpiry("usersListbalance");
        removeItemWithExpiry("usersListlist");
        removeItemWithExpiry("listUsersadd");
        removeItemWithExpiry("listUserssearch");
      })
      .addCase(userDataUpdate.rejected, (state) => {
        state.isFetchingUserUpdate = false;
      })
      .addCase(multiAcessUpdate.pending, (state) => {
        state.isFetchingMultiUpdate = true;
      })
      .addCase(multiAcessUpdate.fulfilled, (state) => {
        state.isFetchingMultiUpdate = false;
      })
      .addCase(multiAcessUpdate.rejected, (state) => {
        state.isFetchingMultiUpdate = false;
      })
      .addCase(limitUpdate.pending, (state) => {
        state.isFetchingLimitsUpdate = true;
      })
      .addCase(limitUpdate.fulfilled, (state) => {
        state.isFetchingLimitsUpdate = false;
      })
      .addCase(limitUpdate.rejected, (state) => {
        state.isFetchingLimitsUpdate = false;
      })
      .addCase(userDataDelete.pending, (state) => {
        state.isFetchingUserDelete = true;
      })
      .addCase(userDataDelete.fulfilled, (state) => {
        removeItemWithExpiry("usersListtxnmode");
        removeItemWithExpiry("usersListeditUser");
        removeItemWithExpiry("usersListbalance");
        removeItemWithExpiry("usersListlist");
        removeItemWithExpiry("listUsersadd");
        removeItemWithExpiry("listUserssearch");
        state.isFetchingUserDelete = false;
      })
      .addCase(userDataDelete.rejected, (state) => {
        state.isFetchingUserDelete = false;
      })
      .addCase(multiAcessDelete.pending, (state) => {
        state.isFetchingMultiDelete = true;
      })
      .addCase(multiAcessDelete.fulfilled, (state) => {
        state.isFetchingMultiDelete = false;
      })
      .addCase(multiAcessDelete.rejected, (state) => {
        state.isFetchingMultiDelete = false;
      })
      .addCase(limitDelete.pending, (state) => {
        state.isFetchingLimitsDelete = true;
      })
      .addCase(limitDelete.fulfilled, (state) => {
        if (state.userLimitData.length === 1) state.userLimitData = [];
        state.isFetchingLimitsDelete = false;
      })
      .addCase(limitDelete.rejected, (state) => {
        state.isFetchingLimitsDelete = false;
      })
      .addCase(userListGet.pending, (state) => {
        state.isFetchingUserList = true;
        state.isFetching = true;
      })
      .addCase(userListGet.fulfilled, (state, action) => {
        state.isFetchingUserList = false;
        state.isFetching = false;
        state.userData = action.payload
          ? (action.payload.usernameExt ?? action.payload.usernames ?? [])
          : [];
        const userMap = {};
        const isManager = !!action.payload.usernameExt;
        state.userData.forEach((userTemp) => {
          userMap[isManager ? userTemp.userEntry?.id : userTemp.id] = isManager
            ? userTemp.userEntry?.systemId
            : userTemp.systemId;
        });
        storeItem("userIdsMap", JSON.stringify(userMap));
      })
      .addCase(userListGet.rejected, (state) => {
        state.isFetchingUserList = false;
        state.isFetching = false;
      })
  
      .addCase(getUserWalletInfo.pending, (state) => {
        state.walletInfoList = [];
      })
      .addCase(getUserWalletInfo.fulfilled, (state, action) => {
        
        const payloadData = action.payload?.data;
        state.walletInfoList = Array.isArray(payloadData) ? payloadData : [];
      })
      .addCase(getUserWalletInfo.rejected, (state) => {
        state.walletInfoList = [];
      })
      .addCase(multiUserListAccess.pending, (state) => {
        state.isFetchingMultiUserAcessGet = true;
        state.isFetching = true;
      })
      .addCase(multiUserListAccess.fulfilled, (state) => {
        state.isFetchingMultiUserAcessGet = false;
        state.isFetching = false;
      })
      .addCase(multiUserListAccess.rejected, (state) => {
        state.isFetchingMultiUserAcessGet = false;
        state.isFetching = false;
      })
      .addCase(updateUserBalance.pending, (state) => {
        state.isFetchingUserBalance = true;
      })
      .addCase(updateUserBalance.fulfilled, (state) => {
        state.isFetchingUserBalance = false;
      })
      .addCase(updateUserBalance.rejected, (state) => {
        state.isFetchingUserBalance = false;
      })
      .addCase(getUsersSessions.pending, (state) => {
        state.isFetchingUserSessions = true;
      })
      .addCase(getUsersSessions.fulfilled, (state) => {
        state.isFetchingUserSessions = false;
      })
      .addCase(getUsersSessions.rejected, (state) => {
        state.isFetchingUserSessions = false;
      })
      .addCase(getUsersConfigurations.pending, (state) => {
        state.isFetchingUserConfigurations = true;
      })
      .addCase(getUsersConfigurations.fulfilled, (state) => {
        state.isFetchingUserConfigurations = false;
      })
      .addCase(getUsersConfigurations.rejected, (state) => {
        state.isFetchingUserConfigurations = false;
      })
      .addCase(getSmscNames.fulfilled, (state, action) => {
        state.smscNames = action.payload;
        state.isFetching = false;
        state.isSuccessSmscNames = true;
        state.isErrorSmscNames = false;
      })
      .addCase(getSmscNames.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getSmscNames.rejected, (state, action) => {
        state.smscNames = [];
        state.isFetching = false;
        state.isErrorSmscNames = true;
        state.isSuccessSmscNames = false;
        state.errorMessageSmscNames = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(fetchTokenDetails.pending, (state) => {
        state.isFetchingTokenDetails = true;
      })
      .addCase(fetchTokenDetails.fulfilled, (state) => {
        state.isFetchingTokenDetails = false;
      })
      .addCase(fetchTokenDetails.rejected, (state) => {
        state.isFetchingTokenDetails = false;
      })
      .addCase(generateUserToken.pending, (state) => {
        state.isFetchingGenerateToken = true;
      })
      .addCase(generateUserToken.fulfilled, (state) => {
        state.isFetchingGenerateToken = false;
      })
      .addCase(generateUserToken.rejected, (state) => {
        state.isFetchingGenerateToken = false;
      })
      .addCase(getWebAccessLog.pending, (state) => {
        state.isFetchingWebAccessLog = true;
      })
      .addCase(getWebAccessLog.rejected, (state, action) => {
        state.isFetchingWebAccessLog = false;
        
        state.webAccessLog = [];
        state.errorMessage = action.payload?.message || "No data found";
        
        if (
          action.payload?.status === 404 ||
          action.payload?.error === "Not Found"
        ) {
          state.webAccessLog = [];
          state.errorMessage = "No web access logs found";
        }
      })
      .addCase(getWebAccessLog.fulfilled, (state, action) => {
        state.isFetchingWebAccessLog = false;
        state.webAccessLog = action.payload.data; 
      })
      .addCase(getHlrSchedule.pending, (state) => {
        state.isFetchingHlrSchedule = true;
      })
      .addCase(getHlrSchedule.fulfilled, (state) => {
        state.isFetchingHlrSchedule = false;
      })
      .addCase(getHlrSchedule.rejected, (state) => {
        state.isFetchingHlrSchedule = false;
      })
      .addCase(addHlrSchedule.pending, (state) => {
        state.isFetchingAddHlrSchedule = true;
      })
      .addCase(addHlrSchedule.fulfilled, (state) => {
        state.isFetchingAddHlrSchedule = false;
      })
      .addCase(addHlrSchedule.rejected, (state) => {
        state.isFetchingAddHlrSchedule = false;
      })
      .addCase(editHlrSchedule.pending, (state) => {
        state.isFetchingEditHlrSchedule = true;
      })
      .addCase(editHlrSchedule.fulfilled, (state) => {
        state.isFetchingEditHlrSchedule = false;
      })
      .addCase(editHlrSchedule.rejected, (state) => {
        state.isFetchingEditHlrSchedule = false;
      })
      .addCase(deleteHlrSchedule.pending, (state) => {
        state.isFetchingDeleteHlrSchedule = true;
      })
      .addCase(deleteHlrSchedule.fulfilled, (state) => {
        state.isFetchingDeleteHlrSchedule = false;
      })
      .addCase(deleteHlrSchedule.rejected, (state) => {
        state.isFetchingDeleteHlrSchedule = false;
      })
      .addCase(getMobileEmailById.pending, (state) => {
        state.isFetchingMobileEmail = true;
      })
      .addCase(getMobileEmailById.fulfilled, (state) => {
        state.isFetchingMobileEmail = false;
      })
      .addCase(getMobileEmailById.rejected, (state) => {
        state.isFetchingMobileEmail = false;
      })
     
      .addCase(getErrorCodeUserData.fulfilled, (state, action) => {
        state.isFetchingErrorCodeUser = false;
        state.errorCodeUserData = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.totalItems = action.payload.totalItems || 0;
        state.currentPage = action.payload.currentPage || 0;
        state.totalPages = action.payload.totalPages || 0;
      })
      .addCase(getErrorCodeUserData.pending, (state) => {
        state.isFetchingErrorCodeUser = true;
      })
      .addCase(getErrorCodeUserData.rejected, (state, action) => {
        state.isFetchingErrorCodeUser = false;
        state.errorCodeUserData = [];
        state.totalItems = 0;
        state.currentPage = 0;
        state.totalPages = 0;
      })
      .addCase(createErrorCodeUserData.fulfilled, (state, action) => {
        state.isFetchingCreateErrorCodeUser = false;
      })
      .addCase(createErrorCodeUserData.pending, (state) => {
        state.isFetchingCreateErrorCodeUser = true;
      })
      .addCase(createErrorCodeUserData.rejected, (state) => {
        state.isFetchingCreateErrorCodeUser = false;
      })
      .addCase(deleteErrorCodeUserData.fulfilled, (state) => {
        state.isFetchingDeleteErrorCodeUser = false;
        if (state.errorCodeUserData.length === 1) state.errorCodeUserData = [];
      })
      .addCase(deleteErrorCodeUserData.pending, (state) => {
        state.isFetchingDeleteErrorCodeUser = true;
      })
      .addCase(deleteErrorCodeUserData.rejected, (state, action) => {
        state.isFetchingDeleteErrorCodeUser = false;
      })
      .addCase(editErrorCodeUserData.fulfilled, (state, action) => {
        state.isFetchingEditErrorCodeUser = false;
      })
      .addCase(editErrorCodeUserData.pending, (state) => {
        state.isFetchingEditErrorCodeUser = true;
      })
      .addCase(editErrorCodeUserData.rejected, (state, action) => {
        state.isFetchingEditErrorCodeUser = false;
      })
     
      .addCase(getUserList.pending, (state) => {
        state.isFetchingUserListNew = true;
      })
      .addCase(getUserList.fulfilled, (state, action) => {
        state.isFetchingUserListNew = false;
       
        const apiResponse = action.payload?.data;
        const requestedPageSize = action.meta?.arg?.pageSize || 10;
       
        let userDataArray = [];
        let totalItems = 0;
        let currentPage = 0;
        let totalPages = 0;
        let pageSize = requestedPageSize;
       
        if (apiResponse) {
          
          if (apiResponse.content && Array.isArray(apiResponse.content)) {
            userDataArray = apiResponse.content;
          } else if (apiResponse.data && Array.isArray(apiResponse.data)) {
            userDataArray = apiResponse.data;
          } else if (Array.isArray(apiResponse)) {
            userDataArray = apiResponse;
          } else {
            userDataArray = [];
          }
      
          
          if (apiResponse.totalItems !== undefined && 
              apiResponse.totalItems !== null && 
              apiResponse.totalItems > 0) {
            totalItems = apiResponse.totalItems;
          }
         
          else if (apiResponse.totalElements !== undefined && apiResponse.totalElements !== null) {
            totalItems = apiResponse.totalElements;
          }
          
          else {
            totalItems = userDataArray.length;
          }
          
          totalPages = apiResponse.totalPages || 0;
          pageSize = apiResponse.size || requestedPageSize;
          
          
          const dataLength = userDataArray.length;
          const backendSaysAllData = (totalItems > 0 && dataLength >= totalItems) || 
                                     (totalPages === 1 && totalItems > pageSize);
          
          if (backendSaysAllData && totalItems > pageSize) {
           
            totalPages = Math.ceil(totalItems / pageSize);
            currentPage = 0; 
          } else {
           
            if (apiResponse.number !== undefined) {
             
              currentPage = Math.max(0, apiResponse.number);
            } else if (apiResponse.currentPage !== undefined) {
             
              currentPage = Math.max(0, apiResponse.currentPage);
            } else {
             
              const requestedPage = action.meta?.arg?.pageNumber ?? 0;
              currentPage = Math.max(0, requestedPage);
            }
            
            
            if (totalPages === 0 && totalItems > 0) {
              totalPages = Math.ceil(totalItems / pageSize);
            }
          }
        }
      
        currentPage = Math.max(0, Math.floor(currentPage));
      
        state.userListData = {
          data: userDataArray,
          totalItems: totalItems,
          currentPage: currentPage,
          totalPages: totalPages,
        };
       
        state.userListTotalItems = totalItems;
        state.userListCurrentPage = currentPage;
        state.userListTotalPages = totalPages;
      })
      .addCase(getUserList.rejected, (state) => {
        state.isFetchingUserListNew = false;
        state.userListData = {
          data: [],
          totalItems: 0,
          currentPage: 0,
          totalPages: 0,
        };
        state.userListTotalItems = 0;
        state.userListCurrentPage = 0;
        state.userListTotalPages = 0;
      });
  },
});

export const { clearStateUser, clearStateSmscNames } = userSlice.actions;
export function clearStateUserAction() {
  return async (dispatch) => {
    dispatch(clearStateUser());
  };
}
export function clearStateNames() {
  return async (dispatch) => {
    dispatch(clearStateSmscNames());
  };
}
export const userSelector = (state) => state.user;
export default userSlice.reducer;